import { useState } from "react";
import unlockIcon from "../assets/lock-open.svg";
import { PhotoType } from "@/generated-api";
import { ImageOff } from "lucide-react";
import * as Sentry from "@sentry/react";

export default function ImageWithSpinner({
  src,
  className,
  imgId,
  photoType = PhotoType.PUBLIC,
  onClick,
  isThumbnail = false,
}: {
  src: string;
  className: string;
  imgId?: string;
  photoType?: PhotoType;
  onClick?: () => void;
  isThumbnail?: boolean;
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  return (
    <div className="relative w-full aspect-[3/4]">
      {isLoading && (
        <div
          className={`${className} absolute inset-0 animate-pulse bg-zinc-900`}
        />
      )}
      {hasError ? (
        <div
          className={`absolute inset-0 flex items-center justify-center text-gray-600 ${
            onClick ? "hover:cursor-pointer" : ""
          }`}
          onClick={onClick}
        >
          <div className="text-center p-4">
            <ImageOff
              className="mx-auto h-12 w-12 text-gray-500 p-2"
              strokeWidth={1.5}
            />
            {!isThumbnail && (
              <div className="mt-2 text-ellipsis">Error loading photo</div>
            )}
          </div>
        </div>
      ) : (
        <img
          src={src}
          key={imgId}
          className={`${className} absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${
            isLoading ? "opacity-0" : "opacity-100"
          }`}
          onLoad={() => {
            setIsLoading(false);
            setHasError(false);
          }}
          onError={() => {
            setIsLoading(false);
            setHasError(true);

            Sentry.captureMessage("Image failed to load", {
              level: "error",
              extra: {
                src,
                imgId,
                photoType,
              },
            });
          }}
          onClick={onClick}
        />
      )}
      {photoType === PhotoType.PRIVATE && (
        <div className="absolute top-2 right-2 text-gray-500">
          <img src={unlockIcon} className="h-7 w-7" />
        </div>
      )}
    </div>
  );
}
